<template>
  <Layout>
      <PageHeader :title="title" :items="items" />
      <!-- <div>
                          <h5 class="font-size-14 mb-1">
                            <a href="javascript: void(0);" class="text-dark"
                            @click="togglePrint"
                              >{{toggleActionDiv ? "View Print-Ready": "Print Mode"}}</a
                            >
                          </h5>
                        </div> -->
      <div v-if="requestInfo" active class="border-0">
        <div class="row">
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div v-if="requestInfo.preferred == 'bank'" class="media-body overflow-hidden">
                    <h5 class="text-truncate font-size-15">
                      {{requestInfo.storeName}}
                    </h5>
                    <p v-if="requestInfo.bankDetails" class="text-muted">
                      {{requestInfo.bankDetails.bankName}} | Acct #: {{requestInfo.bankDetails.bankNumber}} | Branch : {{requestInfo.bankDetails.bankBranch}}
                    </p>
                    <p v-if="requestInfo.bankDetails" class="text-muted">
                      {{requestInfo.bankDetails.nameOnAcct}} | Bank Status : {{requestInfo.bankDetails.isApproved}}
                    </p>
                  </div>
                  <div v-else class="media-body overflow-hidden">
                    <h5 class="text-truncate font-size-15">
                      {{requestInfo.storeName}}
                    </h5>
                    <p v-if="requestInfo.paypalLink" class="text-muted">
                      Paypal : {{requestInfo.paypalLink}}
                    </p>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-lg-4">
              
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Actions</h4>
                <div class="table-responsive">
                  <table
                    class="table table-nowrap table-centered table-hover mb-0 align-middle"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <h5 class="font-size-14 mb-1">
                            <a href="javascript: void(0);" @click="createPayout" class="text-dark"
                              >Approve Payout</a
                            >
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
        <div class="row">
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <h5 class="font-size-15 mt-4">Total: ${{total.toFixed(2)}} | Total Fees: ${{totalFees.toFixed(2)}} | Bank + Anselm Fees ( 5%): ${{bankFees.toFixed(2)}}</h5>
                <h5 class="font-size-15 mt-4">Transactions :</h5>
                <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Invoice Number</th>
                    <th>Trans Id</th>
                    <th>Fee Amount</th>
                    <th>Fee (%)</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody v-if="requestInfo.transactions">
                  <tr v-for="trans in requestInfo.transactions" :key="trans.transactionId">
                    <!-- <th scope="row">1</th> -->
                    <td>{{trans.date.toDate().toLocaleDateString("en-US", options)}}</td>
                    <td>{{trans.invoiceNumber}}</td>
                    <td>{{trans.transactionId}}</td>
                    <td>${{trans.feeAmount.toFixed(2)}}</td>
                    <td>{{trans.feePercent}}%</td>
                    <td>${{trans.total.toFixed(2)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
              </div>
            </div>
            
          
        
          </div>
        </div>
      
      </div>
  </Layout>
</template>

<script>

import Layout from "../../layouts/main"
import PageHeader from "@/components/page-header"
import appConfig from "@/app.config"
import firebase from 'firebase/app';

export default {
    page: {
        title: "Curi | Setup Payouts",
        meta: [{
            name: "description",
            content: appConfig.description
        }]
    },
    components: {
        Layout,
        PageHeader
    },
    data(){
        return {
          total: 0,
          totalFees: 0,
          bankFees: 0,
          editable: false,
          options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
          requestInfo: {
          },
            title: "Setup Payouts",
      items: [
        {
          text: "Setup Payouts",
          href: "/setup-payouts",
        },
        {
          text: "Setup Payouts",
          active: true,
        },
      ],
      toggleActionDiv: true,
        }
    },
    methods: {
      createPayout(){
        this.$bvModal
        .msgBoxConfirm("Create Payout ?")
        .then(async(value)=>{
          if(value){
            this.requestInfo.transactions.forEach(async(element)=>{
              await firebase.firestore().collection("nextPayout")
              .doc(this.requestInfo.id)
              .update({
              transactions: firebase.firestore.FieldValue.arrayRemove(element)
            })
            })
            await firebase.firestore().collection("nextPayout")
              .doc(this.requestInfo.id)
              .update({
                lastUpdated: firebase.firestore.FieldValue.serverTimestamp(),
              })
              await firebase.firestore().collection("payouts")
              .add({
                date: firebase.firestore.FieldValue.serverTimestamp(),
                bankDetails: this.requestInfo.bankDetails,
                preferred: this.requestInfo.preferred,
                paypalLink: this.requestInfo.paypalLink,
                status: "Processing",
                email: this.requestInfo.email ?? null,
                depositor: "Michaelyn B.",
                userId: this.requestInfo.userId,
                storeId: this.requestInfo.id,
                storeName: this.requestInfo.storeName ?? null,
                storeNumber: this.requestInfo.storeNumber ?? null,
                totalDeposited: this.total - this.totalFees,
                feeAmount: this.totalFees,
                bankFee: this.bankFees,
                total: this.total,
                transactions: this.requestInfo.transactions
              }).then((pReference)=>{
                this.$router.push({ path: '/payout-details', query: { id: pReference.id } })
              })
          
            // eslint-disable-next-line no-console
            // console.log(this.requestInfo.transactions);
            
          }
        })
      },
        async getData(docId){
          await firebase.firestore().collection("nextPayout").doc(docId)
          .get().then((singleDoc)=>{
            this.requestInfo = {
                            id: singleDoc.id,
                            bankDetails: singleDoc.data().bankDetails,
                            storeName: singleDoc.data().storeName,
                            storeNumber: singleDoc.data().storeNumber,
                            userId: singleDoc.data().userId,
                            transactions: singleDoc.data().transactions,
                            email: singleDoc.data().email,
                            preferred: singleDoc.data().preferred ?? "bank",
                            paypalLink: singleDoc.data().paypalLink ?? null
                        }
                        //calculate totals :
                        this.requestInfo.transactions.forEach((element)=>{
                          this.total = this.total + element.total
                          this.totalFees = this.totalFees + element.feeAmount
                        })
                        this.bankFees = (5/100 * this.total);
                        // eslint-disable-next-line no-console
                        // console.log(this.requestInfo.bankDetails)
          })
        }
    },
    created(){
      const urlParams = new URLSearchParams(window.location.search)
    if (urlParams) {
      const myParam = urlParams.get("id")
      this.getData(myParam)
    }
    }
}
</script>

<style>

</style>